import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'News',
  meta: {
    icon: 'fa-newspaper-o',
    expanded: false,
    roles: [Global.ROLE.ADMIN]
  },
  path: '/news',
  component: lazyLoading('news/AllNews')
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/news.js